import React from 'react';

// A 3D-styled brand badge — CSS-only (perspective + preserve-3d + a
// simulated extruded back-face + a glossy highlight sweep), not WebGL.
// Kept deliberately CSS-based rather than adding Three.js: this badge
// appears on every page load and in the sidebar all day, so reliability
// and bundle size matter more here than raw visual fidelity.
//
// `breathe`: a very subtle continuous depth pulse — used on the sidebar
// (glanced at occasionally) but NOT on the login page (stares at it while
// typing a password, where a moving element would be distracting).
export default function Logo3D({ icon, size = 64, radius = 20, breathe = false }) {
  return (
    <div className={`logo3d-scene${breathe ? ' logo3d-breathe' : ''}`}>
      <div
        className="logo3d-badge"
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          background: 'var(--color-primary)',
          boxShadow: 'var(--shadow-md)',
        }}
      >
        <div
          className="logo3d-face"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="logo3d-icon-shadow" style={{ display: 'flex' }}>
            {icon}
          </span>
        </div>
      </div>
    </div>
  );
}
